import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import Images from "../Helper/AllImages";
import Setting_Modal from "./Setting_Modal";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import {
  addLiquidity,
  handleMainModal,
  NGROK,
} from "../../Services/mainServices";
import { SET_SETTINGS } from "../../Redux/actions/types";
import { baseAmount } from "@xchainjs/xchain-util";
import {
  getStakeUnits,
  getSwapOutput,
  getSwapOutputWithFee,
  getSwapSlip,
} from "@thorchain/asgardex-util";
import { from } from "rxjs";
export const AddLiquidity = ({ data }) => {
  const myRefSwap2 = useRef();
  const myRefSwap = useRef();
  const [inputValue, setInputValue] = useState("");
  const [addLiquidity_Modal, setAddLiquidity_Modal] = useState(false);
  const [Enum, setEnum] = useState({
    BTC: "BTC",
    BTC_RUNE: "BTC + RUNE",
    RUNE: "RUNE",
    allType: "allType",
    native: "native",
    erc20: "erc20",
    bep2: "bep2",
  });
  const [loading, setLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [emptyError, setEmptyError] = useState(false);
  const [statusLink, setStatusLink] = useState("");
  const [transactionHash, setTransactionHash] = useState("");
  const [YayModal, setYayModal] = useState(false);
  const [runeBalance, setRuneBalance] = useState(0);
  const [search, setSearch] = useState("");
  const [filterType, setFilterType] = useState(Enum.allType);
  const [inSufficientBalance, setInSufficientBalance] = useState(false);
  const [toOptionDropDown, setToOptionDropDown] = useState(false);
  const [fromOptionDropDown, setFromOptionDropDown] = useState(false);
  const [selectedCurrTo, setSelectedCurrTo] = useState("");
  const [liquidityType, setLiquidityType] = useState(Enum.BTC_RUNE);
  const [midgardData, setMidgardData] = useState([]);
  const [settingModal, setSettingModal] = useState(false);
  const [slippagePercent, setSlippagePercent] = useState(0);
  const [selectedCurr, setSelectedCurr] = useState("");
  const [fromAmount, setFromAmount] = useState("");
  const [toAmount, setToAmount] = useState("");
  const walletAddress = useSelector((state) => state.main.walletAddress);
  const dispatch = useDispatch();
  const [slippage, setSlippage] = useState(0);
  const [customSlippage, setCustomSlippage] = useState("");
  const [inputType, setInputType] = useState("text");
  const [customFlag, setCustomFlag] = useState();
  const [speed, setSpeed] = useState("");
  const [placeholderText, setPlaceholderText] = useState("1%");
  const mainState = useSelector((state) => state.main.midgardPool);
  const mainState2 = useSelector((state) => state.main);
  const [tolerenceSelectionState, setTolerenceSelectionState] = useState({
    pointFive: false,
    one: false,
    three: false,
  });
  const [memoSlip, setMemoSlip] = useState("");
  const [slipError, setSlipError] = useState(false);
  const [slipValue, setSlipValue] = useState(0);
  const loggedIn = useSelector((state) => state.main.isLoggedin);
  const assetBalance = useSelector((state) => state.main.assetBalance);
  const walletType = useSelector((state) => state.main.walletType);

  const [popUpData, setPopUpData] = useState([]);

  const [fairPriceDropdown, setFairPriceDropdown] = useState(false);

  const RUNE = {
    asset: "RUNE",
    blockchain: "THOR",
    assetFullName: "Rune",
    rawData: "THOR.RUNE",
    logo: Images.runeImg,
    address: "",
  };

  const handleFairPriceDropdown = () => {
    if(!fairPriceDropdown) {
      setFairPriceDropdown(true)
    } else {
      setFairPriceDropdown(false)
    }
  }

  useEffect(() => {
    console.log("OUT MAIN ><><><><<>><>");
    if (mainState2?.settings) {
      if (mainState2?.settings?.slip) {
        if (mainState2?.settings?.slip == "0.5") {
          console.log("><<><>< 0.5s IF ><><><");

          setCustomFlag(false);
          setCustomSlippage("");
          setSlippage(mainState2?.settings?.slip);
          setSlippagePercent(mainState2?.settings?.slip);

          setSpeed(mainState2?.settings?.speed);

          setTolerenceSelectionState({
            pointFive: true,
            one: false,
            three: false,
          });
        } else if (mainState2?.settings?.slip == "1") {
          console.log("><<><>< 1s IF ><><><");

          setCustomFlag(false);
          setCustomSlippage("");
          setSlippage(mainState2?.settings?.slip);
          setSlippagePercent(mainState2?.settings?.slip);
          setSpeed(mainState2?.settings?.speed);
          setTolerenceSelectionState({
            pointFive: false,
            one: true,
            three: false,
          });
        } else if (mainState2?.settings?.slip == "3") {
          console.log("><<><>< 3s IF ><><><");

          setCustomFlag(false);
          setSpeed(mainState2?.settings?.speed);

          setCustomSlippage("");
          setSlippage(mainState2?.settings?.slip);
          setSlippagePercent(mainState2?.settings?.slip);
          setTolerenceSelectionState({
            pointFive: false,
            one: false,
            three: true,
          });
        } else {
          console.log("><<><>< SLAST IF ><><><");
          let v = mainState2?.settings?.slip.split("%");

          setCustomSlippage(`${mainState2?.settings?.slip}`);
          // setSlippagePercent(mainState?.settings?.slip);
          setSlippagePercent(Number(v[0]));
          setCustomFlag(true);
          setSlippage(mainState2?.settings?.slip);
          setSpeed(mainState2?.settings?.speed);
          setTolerenceSelectionState({
            pointFive: false,
            one: false,
            three: false,
          });
        }
      } else {
        console.log("FINAL ELSE <><><><>>< ");
        setCustomSlippage("");
        setCustomFlag();
        setSlippage("");
        setSpeed("");
      }
      console.log("mainState ><><><><<><><><><> ", mainState2?.settings);
    }
  }, [mainState2]);

  useEffect(() => {
    console.log("+++++++======== ", customFlag);
  }, [customFlag]);

  const handleSlippageInput = (e) => {
    setCustomSlippage(e.target.value);
  };

  const handleBLurInput = () => {
    setInputType("text");
    setPlaceholderText("1%");
    console.log(`HHHH ${customSlippage.split("%")[0]}%`);
    // if (customSlippage.split("%")[0].length > 0)
    setCustomSlippage(`${customSlippage}%`);
  };

  const handleFocusInput = () => {
    if (customSlippage?.split("%"[0]) > 0) {
      setCustomSlippage(customSlippage?.split("%")[0]);
    }
    setInputType("number");
    setCustomSlippage("");
    setSlippage(0);
    setCustomFlag(true);
    setPlaceholderText("%");
  };

  const handleSave = async () => {
    const data = {
      slip: customFlag ? customSlippage : slippage,

      custom: customFlag,

      speed: speed,

      accountAddress: walletAddress,
    };

    console.log("DATA TO SEND <><><><<> ", data);
    await axios.post(`${NGROK}/add/user/history`, data).then((res) => {
      dispatch({
        type: SET_SETTINGS,
        payload: {
          settings: {
            custom: customFlag,
            slip: customFlag ? customSlippage : slippage,
            speed: speed,
          },
        },
      });

      setSlippagePercent(slippage);
      setSettingModal(false);
      setAddLiquidity_Modal(true);
    });
  };

  const gettingLogos = (t) => {
    let midgardPool = mainState;

    let ticker = t?.asset?.ticker;
    if (t?.asset?.ticker?.toLowerCase() === "rune") {
      return (
        <img
          src={Images.runeImg}
          width="24px"
          height="24px"
          style={{ marginRight: "6px" }}
        />
      );
    } else {
      let res = midgardPool?.find(
        (d) => d?.asset?.toLowerCase() === ticker?.toLowerCase()
      );
      return (
        <img
          src={res?.logo}
          width="24px"
          height="24px"
          style={{ marginRight: "6px" }}
        />
      );
    }
  };

  useEffect(() => {
    setToAmount("");
    setFromAmount("");
    setSlipError(false);
    setSlipValue(0);
  }, [selectedCurr]);

  //Slippage Implementation
  useEffect(() => {
    console.log("Just checking============", slippagePercent);
  }, [slippagePercent]);
  useEffect(async () => {
    setSlipError(false);
    setToAmount("");
    setSlipValue(0);
    if (slippagePercent && fromAmount && !inSufficientBalance) {
      if (fromAmount && fromAmount > 0) {
        let fromData;
        if (selectedCurr?.asset?.ticker === "RUNE") {
          fromData = RUNE;
        } else {
          fromData = mainState.find(
            (data) =>
              data.blockchain === selectedCurr.asset.chain &&
              data.asset === selectedCurr.asset.ticker
          );
        }
        let isRUNE = true;

        let fromPoolSlip = {
          runeBalance: baseAmount(fromData?.runeDepth),
          assetBalance: baseAmount(fromData?.assetDepth),
        };
        //  let toPoolSlip = {
        //    runeBalance: baseAmount(selectedCurrTo?.runeDepth),
        //    assetBalance: baseAmount(selectedCurrTo?.assetDepth),
        //  };
        // console.log("FROM AMOUNT+========", fromAmount);
        // console.log("FROM AMOUNT+========", isRUNE);
        // console.log("FROM AMOUNT+========", fromPoolSlip.runeBalance.amount());
        // console.log("FROM AMOUNT+========", fromPoolSlip.assetBalance.amount());

        let response;
        if (isRUNE) {
          response = await getSwapSlip(
            baseAmount(fromAmount * 10 ** 8),
            fromPoolSlip,
            isRUNE
          );
        }

        let slipValueVar = response.c[0] / 10 ** 12;
        console.log("Slip Value========", Number(slipValueVar));
        setSlipValue(slipValueVar);
        let response2;
        let slipValueMemo;
        // MINIMUM RECIEPIENT
        if (isRUNE) {
          response = await getSwapOutputWithFee(
            baseAmount(fromAmount * 10 ** 8),
            fromPoolSlip,
            isRUNE,
            baseAmount(1)
          );
          response2 = await getSwapOutput(
            baseAmount(fromAmount * 10 ** 8),
            fromPoolSlip,
            isRUNE
          );
          slipValueMemo = (100 - slippagePercent) / 100;
          slipValueMemo = slipValueMemo * response2.amount();
          console.log("TORUNE");
        }
        let slipWithDecimal = slipValueMemo / 10 ** 8;
        console.log("SLIP WITH DECIMAL=========", slipWithDecimal);
        if (slipValueVar <= slippagePercent && slipWithDecimal > 0) {
          let check = slipWithDecimal.toString().split(".");
          let res = check[1].substring(0, 4);
          res = res + "333";
          console.log("checking Here====", res);
          setMemoSlip(res);

          setToAmount(response.amount().c[0] / 10 ** 8);
        } else {
          setSlipError(true);
        }
      }
    }
  }, [fromAmount]);

  useEffect(() => {
    console.log(
      "balance Checking=====",
      selectedCurr?.amount?.amount().c[0] /
        Math.pow(10, selectedCurr?.amount?.decimal)
    );
    if (selectedCurr?.amount?.amount().c[0] > 0 && runeBalance > 0) {
      setInSufficientBalance(false);
    } else {
      setInSufficientBalance(true);
    }
  }, [selectedCurr]);
  useEffect(() => {
    if (assetBalance) {
      let res = mainState?.find(
        (d) => d?.asset === data?.asset && d?.blockchain === data?.blockchain
      );
      let balance = assetBalance?.find(
        (d) =>
          d?.asset?.ticker === data?.asset &&
          d?.asset?.chain === data?.blockchain
      );
      let rune = assetBalance?.find((d) => d?.asset?.ticker === "RUNE");
      if (!balance) {
        let temp = {
          asset: {
            chain: res?.blockchain,
            symbol: res?.asset,
            ticker: res?.asset,
          },
        };
        setInSufficientBalance(true);
        setSelectedCurr(temp);
      } else if (balance?.amount?.amount().c[0] > 0) {
        if (rune && rune?.amount?.amount().c[0] > 0) {
          setRuneBalance(
            Number(
              rune?.amount?.amount().c[0] / Math.pow(10, rune?.amount?.decimal)
            )
          );
        } else {
          setInSufficientBalance(true);
        }
        setSelectedCurr(balance);
      } else if (balance?.amount?.amount().c[0] <= 0) {
        setInSufficientBalance(true);
        setSelectedCurr(balance);
      }
      setPopUpData(assetBalance);

      setSelectedCurrTo(res);
    }
  }, [addLiquidity_Modal]);

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
    function handleClick(e) {
      if (myRefSwap2 && myRefSwap2.current) {
        const ref = myRefSwap2.current;
        if (!ref.contains(e.target)) {
          setToOptionDropDown(false);
        }
      }
      if (myRefSwap && myRefSwap.current) {
        const ref = myRefSwap.current;
        if (!ref.contains(e.target)) {
          setFromOptionDropDown(false);
        }
      }
    }
  }, []);

  const handleAddLiqudityModal = () => {
    if (loggedIn) {
      setAddLiquidity_Modal(true);
    } else {
      dispatch(handleMainModal(true));
    }
  };

  const filterAllTypeTo = (e) => {
    e.preventDefault();
    setFilterType(Enum.allType);
    setMidgardData(mainState);
    setPopUpData(assetBalance);
  };
  const filterNativeTo = (e) => {
    e.preventDefault();
    setFilterType(Enum.native);
    let res = assetBalance.filter(
      (data) => data?.asset?.chain === data?.asset?.ticker
    );

    setPopUpData(res);
  };

  const filterERC20To = (e) => {
    e.preventDefault();
    setFilterType(Enum.erc20);

    let res = assetBalance.filter(
      (data) => data?.asset?.chain === "ETH" && data?.asset?.ticker !== "ETH"
    );

    setPopUpData(res);
  };

  const filterBEP2To = (e) => {
    e.preventDefault();
    setFilterType(Enum.bep2);

    let res = assetBalance.filter(
      (data) => data?.asset?.chain === "BNB" && data?.asset?.ticker !== "BNB"
    );

    setPopUpData(res);
  };
  const implementSearch = (e) => {
    setSearch(e.target.value);
  };

  function financial(x) {
    return Number.parseFloat(x).toFixed(2);
  }
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  // useEffect(() => {
  //   if (inputValue === "") {
  //     setPoolPrice(selectedCurrTo?.assetPriceUSD);
  //   } else if (inputValue >= 0) {
  //     setPoolPrice(Number(inputValue) * selectedCurrTo?.assetPriceUSD);
  //   }
  // }, [inputValue]);

  const submitLiquidity = () => {
    // setSlipError(false);
    if (loggedIn && fromAmount > 0 && !slipError) {
      console.log("inn 1");
      let fromData;
      if (selectedCurr?.asset?.ticker === "RUNE") {
        fromData = RUNE;
      } else {
        fromData = mainState.find(
          (data) =>
            data.blockchain === selectedCurr.asset.chain &&
            data.asset === selectedCurr.asset.ticker
        );
      }

      // let check = getStakeUnits()
      const decimal = selectedCurr.amount.decimal;
      if (fromData) {
        let stake = {
          asset: baseAmount(fromAmount),
          rune: baseAmount(toAmount),
        };
        let poolData = {
          assetBalance: baseAmount(fromData?.assetDepth),
          runeBalance: baseAmount(fromData?.runeDepth),
        };

        let check = getStakeUnits(stake, poolData);

        dispatch(
          addLiquidity(
            fromData,
            RUNE,
            fromAmount,
            decimal,
            mainState,
            setYayModal,
            setAddLiquidity_Modal,
            setTransactionHash,
            setStatusLink,
            setLoading,
            walletType,
            selectedCurr,
            memoSlip
          )
        );
      }
    } else {
      // console.log("loggedOUT");
      dispatch(handleMainModal(true));
    }
  };

  return (
    <div>
      {/*Yay Modal*/}

      <Modal
        show={YayModal}
        onHide={() => {
          setYayModal(false);
        }}
        // backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          {/* <!-- Modal --> */}

          <div
            // class="modal fade"
            id="successBuy"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div>
              <div>
                <div class="modal-body">
                  <div class="d-flex flex-row justify-content-end">
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="n-modalCloseIcon"
                      onClick={() => {
                        setYayModal(false);
                      }}
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M13.2929 13.2929C13.6834 12.9024 14.3166 12.9024 14.7071 13.2929L20 18.5858L25.2929 13.2929C25.6834 12.9024 26.3166 12.9024 26.7071 13.2929C27.0976 13.6834 27.0976 14.3166 26.7071 14.7071L21.4142 20L26.7071 25.2929C27.0976 25.6834 27.0976 26.3166 26.7071 26.7071C26.3166 27.0976 25.6834 27.0976 25.2929 26.7071L20 21.4142L14.7071 26.7071C14.3166 27.0976 13.6834 27.0976 13.2929 26.7071C12.9024 26.3166 12.9024 25.6834 13.2929 25.2929L18.5858 20L13.2929 14.7071C12.9024 14.3166 12.9024 13.6834 13.2929 13.2929Z"
                        fill="#23262F"
                      />
                      <rect
                        x="1"
                        y="1"
                        width="38"
                        height="38"
                        rx="19"
                        stroke="#E6E8EC"
                        stroke-width="2"
                      />
                    </svg>
                  </div>
                  <div class="d-flex justify-content-center  mb-3">
                    <h1
                      class="n-yayText"
                      style={{
                        fontWeight: "bold",
                        fontFamily: "DM Sans",
                        fontSize: "48px",
                        paddingRight: "10px",
                      }}
                    >
                      Yay!
                    </h1>
                    <img src={Images.Yay} />
                  </div>
                  <div class="d-flex justify-content-center ">
                    <p class="yayText">Your transaction has been initiated!</p>
                  </div>
                  <div class=" ">
                    <a
                      href={statusLink}
                      class=""
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        fontSize: "14px",
                        width: "450px",
                        display: "block",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                      target="_blank"
                    >
                      {statusLink}
                    </a>
                  </div>
                  <div class="transactionclasss">
                    <div class="d-flex justify-content-between">
                      <p
                        style={{
                          color: "#777E90",
                          fontSize: "14px",
                          fontFamily: "Poppins",
                          lineHeight: "24px",
                          marginBottom: "10px",
                        }}
                      >
                        Status
                      </p>
                      <p
                        style={{
                          color: "#777E90",
                          fontSize: "14px",
                          paddingRight: "48px",
                          fontFamily: "Poppins",
                          lineHeight: "24px",
                          marginBottom: "10px",
                        }}
                      >
                        Transaction ID
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p
                        style={{
                          color: "#58BD7D",
                          fontWeight: "500",
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          marginBottom: "10px",
                        }}
                      >
                        Initiated
                      </p>
                      <br />
                      <p
                        class="n-modalSubHeading"
                        s
                        style={{
                          marginLeft: "50px",
                          fontWeight: "500",
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          overflow: "hidden",
                          lineHeight: "24px",
                          marginBottom: "10px",
                        }}
                      >
                        {transactionHash ? <> {transactionHash}</> : null}
                      </p>
                    </div>
                    {/* <hr class="solid" /> */}
                    <div class="d-flex flex-row justify-content-between">
                      <p
                        style={{
                          color: "#777E90",
                          fontSize: "14px",
                          paddingRight: "48px",
                          fontFamily: "Poppins",
                          lineHeight: "24px",
                          marginBottom: "0",
                        }}
                      >
                        Address
                      </p>
                      <p
                        class="n-modalSubHeading"
                        style={{
                          fontWeight: "500",
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          marginBottom: "0",
                          color: "#23262F",
                        }}
                      >
                        0msx836930...87r398
                      </p>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between pt-5">
                    <p
                      style={{
                        fontWeight: "500",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#353945",
                      }}
                      class="n-modalSubHeading"
                    >
                      {/* 1.1137 */}
                      {toAmount}
                    </p>
                    <p
                      style={{
                        fontWeight: "500",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#353945",
                      }}
                      class="n-modalSubHeading"
                    >
                      {/* BTC */}
                      {selectedCurrTo?.asset}
                    </p>
                  </div>
                  <hr class="solid" />
                  <div class="d-flex justify-content-between">
                    <p
                      class="servicefee"
                      style={{
                        fontWeight: "500",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#777E91",
                      }}
                    >
                      Service fee
                    </p>
                    <p
                      style={{
                        fontWeight: "600",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#353945",
                      }}
                      class="n-modalSubHeading"
                    >
                      0.0045 ETH
                    </p>
                  </div>
                  <div class="d-flex justify-content-between ">
                    <p
                      class="servicefee"
                      style={{
                        fontWeight: "500",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#777E91",
                      }}
                    >
                      You will get
                    </p>
                    <p
                      style={{
                        fontWeight: "600",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#353945",
                      }}
                      class="n-modalSubHeading"
                    >
                      {toAmount} {selectedCurrTo?.asset}
                    </p>
                  </div>
                </div>
                <div class="d-flex justify-content-center pb-3 pt-2 pl-3 pr-3">
                  {/* <button
                    type="button"
                    class="btn btn-primary btn-lg btnHoverWhite"
                  >
                    Wallet
                  </button> */}
                </div>
              </div>
            </div>
          </div>
          {/* <!-- modal end --> */}
        </Modal.Body>
      </Modal>

      <Modal
        show={settingModal}
        onHide={() => {
          if (mainState2) {
            if (mainState2?.settings?.slip == "0.5") {
              console.log(1);
              setCustomFlag(false);
              setCustomSlippage("");
              setSlippage(mainState2?.settings?.slip);
              setSpeed(mainState2?.settings?.speed);
              setSettingModal(false);
              setTolerenceSelectionState({
                pointFive: true,
                one: false,
                three: false,
              });
            } else if (mainState2?.settings?.slip == "1") {
              console.log(2);

              setCustomFlag(false);
              setCustomSlippage("");
              setSlippage(mainState2?.settings?.slip);
              setSpeed(mainState2?.settings?.speed);
              setSettingModal(false);
              setTolerenceSelectionState({
                pointFive: false,
                one: true,
                three: false,
              });
            } else if (mainState2?.settings?.slip == "3") {
              console.log(3);

              setCustomFlag(false);
              setCustomSlippage("");
              setSettingModal(false);
              setTolerenceSelectionState({
                pointFive: false,
                one: false,
                three: true,
              });
            } else {
              console.log(4);

              setCustomSlippage(`${mainState2?.settings?.slip}`);

              setCustomFlag(true);

              setSlippage(mainState2?.settings?.slip);
              setSpeed(mainState2?.settings?.speed);
              setSettingModal(false);
              setTolerenceSelectionState({
                pointFive: false,
                one: false,
                three: false,
              });
            }
          }
          // setModal(true);
        }}
        keyboard={false}
        size="md"
      >
        {/* <Modal.Header
          closeButton
          style={{ borderBottom: "none" }}
        ></Modal.Header> */}
        <Modal.Body>
          {/* <!-- Modal --> */}
          <div
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div role="document">
              <div>
                <div class="modal-body">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex">
                      {/* <img
                        class=""
                        style={{
                          height: "10px",
                          marginTop: "15px",
                          paddingRight: "12px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSettingModal(false);
                          if (mainState?.length) {
                            console.log(
                              "mainState ><><><><<><><><><> ",
                              mainState?.settings
                            );
                            setCustomFlag(mainState?.settings.custom);
                            setSlippage(mainState?.settings.slip);
                            setSpeed(mainState?.settings.speed);
                            setCustomSlippage(mainState?.settings.slip);
                          }
                        }}
                        src={Images.lefttwoline}
                      /> */}
                      {/* <svg
                        className="backArrow mr-2"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => {
                          if (mainState) {
                            if (mainState?.settings?.slip == "0.5") {
                              setCustomFlag(false);
                              setCustomSlippage("");
                              setSlippage(mainState?.settings?.slip);
                              setSpeed(mainState?.settings?.speed);
                              setSettingModal(false);
                            } else if (mainState?.settings?.slip == "1") {
                              setCustomFlag(false);
                              setCustomSlippage("");
                              setSlippage(mainState?.settings?.slip);
                              setSpeed(mainState?.settings?.speed);
                              setSettingModal(false);
                            } else if (mainState?.settings?.slip == "3") {
                              setCustomFlag(false);
                              setCustomSlippage("");
                              setSettingModal(false);
                            } else {
                              setCustomSlippage(`${mainState?.settings?.slip}`);

                              setCustomFlag(true);
                              setSlippage(mainState?.settings?.slip);
                              setSpeed(mainState?.settings?.speed);
                              setSettingModal(false);
                            }
                          }
                        }}
                        style={{
                          marginTop: "2px",
                          cursor: "pointer",
                        }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M18.9428 10.3905C19.4635 10.9112 19.4635 11.7554 18.9428 12.2761L15.219 16L18.9428 19.7239C19.4635 20.2446 19.4635 21.0888 18.9428 21.6095C18.4221 22.1302 17.5779 22.1302 17.0572 21.6095L12.3905 16.9428C11.8698 16.4221 11.8698 15.5779 12.3905 15.0572L17.0572 10.3905C17.5779 9.86983 18.4221 9.86983 18.9428 10.3905Z"
                          fill="#23262F"
                        />
                      </svg> */}
                      <svg
                        className="backArrow mr-2"
                        width="32"
                        height="33"
                        viewBox="0 0 32 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => {
                          if (mainState2) {
                            if (mainState2?.settings?.slip == "0.5") {
                              setCustomFlag(false);
                              setCustomSlippage("");
                              setSlippage(mainState2?.settings?.slip);
                              setSpeed(mainState2?.settings?.speed);
                              setSettingModal(false);
                              setTolerenceSelectionState({
                                pointFive: true,
                                one: false,
                                three: false,
                              });
                              setAddLiquidity_Modal(true);
                            } else if (mainState2?.settings?.slip == "1") {
                              setCustomFlag(false);
                              setCustomSlippage("");
                              setSlippage(mainState2?.settings?.slip);
                              setSpeed(mainState2?.settings?.speed);
                              setSettingModal(false);
                              setTolerenceSelectionState({
                                pointFive: false,
                                one: true,
                                three: false,
                              });
                              setAddLiquidity_Modal(true);
                            } else if (mainState2?.settings?.slip == "3") {
                              setCustomFlag(false);
                              setCustomSlippage("");
                              setSettingModal(false);
                              setTolerenceSelectionState({
                                pointFive: false,
                                one: false,
                                three: true,
                              });
                              setAddLiquidity_Modal(true);
                            } else {
                              setCustomSlippage(
                                `${mainState2?.settings?.slip}`
                              );

                              setCustomFlag(true);
                              setSlippage(mainState2?.settings?.slip);
                              setSpeed(mainState2?.settings?.speed);
                              setSettingModal(false);
                              setTolerenceSelectionState({
                                pointFive: false,
                                one: false,
                                three: false,
                              });
                              setAddLiquidity_Modal(true);
                            }
                          }
                        }}
                        style={{
                          marginTop: "3px",
                        }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.2108 10.1876C12.6697 9.68812 11.8261 9.72186 11.3267 10.2629L7.01897 14.9296C6.5475 15.4403 6.5475 16.2276 7.01896 16.7383L11.3267 21.405C11.8261 21.9461 12.6697 21.9799 13.2108 21.4804C13.7519 20.9809 13.7856 20.1374 13.2861 19.5963L11.044 17.1673L23.9987 17.1673C24.7351 17.1673 25.332 16.5703 25.332 15.8339C25.332 15.0976 24.7351 14.5006 23.9987 14.5006L11.044 14.5006L13.2861 12.0717C13.7856 11.5306 13.7519 10.6871 13.2108 10.1876Z"
                          fill="#777E91"
                        />
                      </svg>
                      <p class="yahparagraph">Settings</p>
                    </div>
                    <div>
                      {/* <img
                        className="popupcrosss"
                        onClick={() => {
                          setSettingModal(false);
                          if (mainState?.length) {
                            console.log(
                              "mainState ><><><><<><><><><> ",
                              mainState?.settings
                            );
                            setCustomFlag(mainState?.settings.custom);
                            setSlippage(mainState?.settings.slip);
                            setSpeed(mainState?.settings.speed);
                            setCustomSlippage(mainState?.settings.slip);
                          }
                          // setModal(true);
                        }}
                        src={Images.crossicon}
                      /> */}
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="n-modalCloseIcon"
                        onClick={() => {
                          if (mainState2) {
                            if (mainState2?.settings?.slip == "0.5") {
                              setCustomFlag(false);
                              setCustomSlippage("");
                              setSlippage(mainState2?.settings?.slip);
                              setSpeed(mainState2?.settings?.speed);
                              setSettingModal(false);
                              setTolerenceSelectionState({
                                pointFive: true,
                                one: false,
                                three: false,
                              });
                            } else if (mainState2?.settings?.slip == "1") {
                              setCustomFlag(false);
                              setCustomSlippage("");
                              setSlippage(mainState2?.settings?.slip);
                              setSpeed(mainState2?.settings?.speed);
                              setSettingModal(false);
                              setTolerenceSelectionState({
                                pointFive: false,
                                one: true,
                                three: false,
                              });
                            } else if (mainState2?.settings?.slip == "3") {
                              setCustomFlag(false);
                              setCustomSlippage("");
                              setSettingModal(false);
                              setTolerenceSelectionState({
                                pointFive: false,
                                one: false,
                                three: true,
                              });
                            } else {
                              setCustomSlippage(
                                `${mainState2?.settings?.slip}`
                              );

                              setCustomFlag(true);
                              setSlippage(mainState2?.settings?.slip);
                              setSpeed(mainState2?.settings?.speed);
                              setSettingModal(false);
                              setTolerenceSelectionState({
                                pointFive: false,
                                one: false,
                                three: false,
                              });
                            }
                          }
                        }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.2929 13.2929C13.6834 12.9024 14.3166 12.9024 14.7071 13.2929L20 18.5858L25.2929 13.2929C25.6834 12.9024 26.3166 12.9024 26.7071 13.2929C27.0976 13.6834 27.0976 14.3166 26.7071 14.7071L21.4142 20L26.7071 25.2929C27.0976 25.6834 27.0976 26.3166 26.7071 26.7071C26.3166 27.0976 25.6834 27.0976 25.2929 26.7071L20 21.4142L14.7071 26.7071C14.3166 27.0976 13.6834 27.0976 13.2929 26.7071C12.9024 26.3166 12.9024 25.6834 13.2929 25.2929L18.5858 20L13.2929 14.7071C12.9024 14.3166 12.9024 13.6834 13.2929 13.2929Z"
                          fill="#23262F"
                        />
                        <rect
                          x="1"
                          y="1"
                          width="38"
                          height="38"
                          rx="19"
                          stroke="#E6E8EC"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <p style={{ fontFamily: "Poppins", marginTop: "32px" }}>
                      Slipperage Tolerance
                    </p>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>
                      <input
                        type={inputType}
                        // class="btn w-secondaryInpput 123 n-tableSeachDark"
                        className={
                          customFlag
                            ? "btn n-primaryButton n-primaryDark"
                            : "btn n-secondaryButton n-secondaryDark"
                        }
                        style={{
                          textAlign: "left",
                          width: "80px",
                          boxShadow:
                            // customFlag
                            //   ? "0 0 0 0.2rem rgb(0 123 255 / 25%)"
                            //   :
                            "none",

                          // backgroundColor: customFlag ? "#3772ff" : "white",
                          // color: customFlag ? "white" : "black",
                        }}
                        placeholder={placeholderText}
                        value={customSlippage}
                        onChange={handleSlippageInput}
                        onBlur={handleBLurInput}
                        onFocus={handleFocusInput}
                        onClick={() => {
                          setCustomFlag(true);
                        }}
                      />
                    </div>
                    {/* <button
                      type="button"
                      class="btn n-secondaryButton 123"
                      style={{ width: "80px" }}
                      onClick={() => {
                        setSlippage(1);
                      }}
                    >
                      1%
                     
                    </button> */}
                    <button
                      style={{
                        width: "80px",
                        boxShadow:
                          // !customFlag && slippage == "0.5"
                          //   ? "0 0 0 0.2rem rgb(0 123 255 / 25%)"
                          //   :
                          "none",
                        // backgroundColor:
                        //   tolerenceSelectionState.pointFive && !customFlag
                        //     ? "#3772ff"
                        //     : "white",
                        // color: tolerenceSelectionState.pointFive
                        //   ? "white"
                        //   : "black",
                      }}
                      type="button"
                      // class="btn n-secondaryButton"
                      className={
                        tolerenceSelectionState.pointFive && !customFlag
                          ? "btn n-primaryButton n-primaryDark"
                          : "btn n-secondaryButton n-secondaryDark"
                      }
                      onClick={() => {
                        setSlippage(0.5);
                        setCustomFlag(false);
                      }}
                      onFocus={() => {
                        setTolerenceSelectionState({
                          pointFive: true,
                          one: false,
                          three: false,
                        });
                        setCustomFlag(false);
                      }}
                    >
                      0.5%
                      {/* <img className="mb-1" src={Images.morearticle}/> */}
                    </button>
                    <button
                      style={{
                        width: "80px",
                        boxShadow:
                          // !customFlag && slippage == "1"
                          //   ? "0 0 0 0.2rem rgb(0 123 255 / 25%)"
                          //   :
                          "none",
                        // backgroundColor:
                        //   tolerenceSelectionState.one && !customFlag
                        //     ? "#3772ff"
                        //     : "white",
                        // color: tolerenceSelectionState.one ? "white" : "black",
                      }}
                      type="button"
                      // class="btn n-secondaryButton"
                      className={
                        tolerenceSelectionState.one && !customFlag
                          ? "btn n-primaryButton n-primaryDark"
                          : "btn n-secondaryButton n-secondaryDark"
                      }
                      onClick={() => {
                        setSlippage(1);
                        setCustomFlag(false);
                      }}
                      onFocus={() => {
                        setTolerenceSelectionState({
                          pointFive: false,
                          one: true,
                          three: false,
                        });
                        setCustomFlag(false);
                      }}
                    >
                      1%
                      {/* <img className="mb-1" src={Images.morearticle}/> */}
                    </button>
                    <button
                      style={{
                        width: "80px",
                        boxShadow:
                          // !customFlag && slippage == "3"
                          //   ? "0 0 0 0.2rem rgb(0 123 255 / 25%)"
                          //   :
                          "none",
                        // backgroundColor:
                        //   tolerenceSelectionState.three && !customFlag
                        //     ? "#3772ff"
                        //     : "white",
                        // color: tolerenceSelectionState.three
                        //   ? "white"
                        //   : "black",
                      }}
                      type="button"
                      // class="btn n-secondaryButton"
                      className={
                        tolerenceSelectionState.three && !customFlag
                          ? "btn n-primaryButton n-primaryDark"
                          : "btn n-secondaryButton n-secondaryDark"
                      }
                      onClick={() => {
                        setSlippage(3);
                        setCustomFlag(false);
                      }}
                      onFocus={() => {
                        setTolerenceSelectionState({
                          pointFive: false,
                          one: false,
                          three: true,
                        });
                        setCustomFlag(false);
                      }}
                    >
                      3%
                      {/* <img className="mb-1" src={Images.morearticle}/> */}
                    </button>
                  </div>
                  <p style={{ fontFamily: "Poppins", marginTop: "32px" }}>
                    Transaction Speed
                  </p>
                  <div className="d-flex justify-content-between">
                    <button
                      style={{
                        width: "80px",
                        boxShadow:
                          // speed == "normal"
                          //   ? "0 0 0 0.2rem rgb(0 123 255 / 25%)"
                          //   :
                          "none",
                        // backgroundColor:
                        //   speed == "normal" ? "#3772ff" : "white",
                        // color: speed == "normal" ? "white" : "black",
                      }}
                      type="button"
                      // class="btn n-secondaryButton"
                      className={
                        speed == "normal"
                          ? "btn n-primaryButton n-primaryDark"
                          : "btn n-secondaryButton n-secondaryDark"
                      }
                      onClick={() => setSpeed("normal")}
                      // onFocus={() => setSpeed("normal")}
                    >
                      Normal
                      {/* <img className="mb-1" src={Images.morearticle}/> */}
                    </button>
                    <button
                      style={{
                        width: "80px",
                        boxShadow:
                          // speed == "fast"
                          //   ? "0 0 0 0.2rem rgb(0 123 255 / 25%)"
                          //   :
                          "none",
                        // backgroundColor: speed == "fast" ? "#3772ff" : "white",
                        // color: speed == "fast" ? "white" : "black",
                      }}
                      type="button"
                      // class="btn n-secondaryButton"
                      className={
                        speed == "fast"
                          ? "btn n-primaryButton n-primaryDark"
                          : "btn n-secondaryButton n-secondaryDark"
                      }
                      onClick={() => setSpeed("fast")}
                      // onFocus={() => setSpeed("fast")}
                    >
                      Fast
                      {/* <img className="mb-1" src={Images.morearticle}/> */}
                    </button>
                    <button
                      style={{
                        width: "80px",
                        boxShadow:
                          // speed == "instant"
                          //   ? "0 0 0 0.2rem rgb(0 123 255 / 25%)"
                          //   :
                          "none",
                        // backgroundColor:
                        //   speed == "instant" ? "#3772ff" : "white",
                        // color: speed == "instant" ? "white" : "black",
                      }}
                      type="button"
                      // class="btn n-secondaryButton"
                      className={
                        speed == "instant"
                          ? "btn n-primaryButton n-primaryDark"
                          : "btn n-secondaryButton n-secondaryDark"
                      }
                      onClick={() => setSpeed("instant")}
                      // onFocus={() => setSpeed("instant")}
                    >
                      Instant
                      {/* <img className="mb-1" src={Images.morearticle}/> */}
                    </button>
                  </div>
                  <div
                    style={{ marginTop: "32px" }}
                    class="d-flex justify-content"
                  >
                    <button
                      style={{ width: "100%" }}
                      className="btn n-primaryButton n-primaryDark"
                      onClick={handleSave}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- modal end --> */}
        </Modal.Body>
      </Modal>

      {/*AddLiquidity PopUp Modal BTC */}

      <Modal
        show={addLiquidity_Modal}
        onHide={() => {
          setAddLiquidity_Modal(false);
        }}
        keyboard={false}
        size="md"
        className="w-pop-main"
      >
        {/* <Modal.Header
          closeButton
          style={{ borderBottom: "none" }}
        ></Modal.Header> */}
        <Modal.Body className="p-0">
          {/* <!-- Modal --> */}
          <div
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div role="document">
              <div>
                <div class="modal-body p-0">
                  <div style={{ padding: "32px" }}>
                    <div class="d-flex flex-row justify-content-end">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="n-modalCloseIcon"
                        onClick={() => {
                          setAddLiquidity_Modal(false);
                        }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0.292893 0.292893C0.683417 -0.0976309 1.31658 -0.0976309 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L8.41421 7L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L7 8.41421L1.70711 13.7071C1.31658 14.0976 0.683418 14.0976 0.292893 13.7071C-0.0976309 13.3166 -0.0976309 12.6834 0.292893 12.2929L5.58579 7L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893Z"
                          fill="#23262F"
                        />
                      </svg>
                    </div>
                    <div class="d-flex justify-content-center">
                      <p class="n-yahparagraph">Deposit Liquidity</p>
                    </div>
                    {/* <div
                      class="d-flex flex-row justify-content-center align-items-center"
                      style={{ marginTop: "20px" }}
                    >
                      <div class="n-liquidityToggle">
                        <label class="switch" style={{marginBottom: "0"}}>
                          <input type="checkbox" />
                          <span class="slider round"></span>
                        </label>
                      </div>
                      <p class="n-toggleText">Auto-swap uneven amounts</p>
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ marginLeft: "10px" }}
                      >
                        <path
                          d="M8.50001 1C7.01665 1 5.5666 1.43987 4.33323 2.26398C3.09986 3.08809 2.13856 4.25943 1.57091 5.62987C1.00325 7.00032 0.854725 8.50832 1.14411 9.96318C1.4335 11.418 2.14781 12.7544 3.1967 13.8033C4.2456 14.8522 5.58197 15.5665 7.03683 15.8559C8.49169 16.1453 9.99969 15.9968 11.3701 15.4291C12.7406 14.8614 13.9119 13.9001 14.736 12.6668C15.5601 11.4334 16 9.98336 16 8.5C16 6.51088 15.2098 4.60322 13.8033 3.1967C12.3968 1.79018 10.4891 1 8.50001 1Z"
                          stroke="#777E90"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M6.11377 6.21123C6.11377 6.21123 6.14957 5.46549 6.94772 4.8233C7.42116 4.44191 7.98877 4.33154 8.50013 4.32387C8.9659 4.3179 9.38181 4.39504 9.63067 4.5135C10.0568 4.71634 10.8865 5.21151 10.8865 6.26449C10.8865 7.37245 10.1621 7.87572 9.33664 8.42927C8.51121 8.98282 8.28706 9.58367 8.28706 10.2046"
                          stroke="#777E90"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                        />
                        <path
                          d="M8.2499 13.2682C8.71934 13.2682 9.0999 12.8876 9.0999 12.4182C9.0999 11.9487 8.71934 11.5682 8.2499 11.5682C7.78046 11.5682 7.3999 11.9487 7.3999 12.4182C7.3999 12.8876 7.78046 13.2682 8.2499 13.2682Z"
                          fill="#777E90"
                        />
                      </svg>
                    </div> */}

                    {/*BTC_RUNE*/}
                    {liquidityType === Enum.BTC_RUNE ? (
                      <div style={{ marginTop: "32px" }}>
                        <div
                          class="d-flex align-items-center justify-content-between"
                          style={{ marginTop: "32px" }}
                        >
                          <div class="w-currencySelect" ref={myRefSwap}>
                            <div class="w-currency-new">
                              <div
                                class="d-flex flex-row align-items-center"
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "40px",
                                }}
                                onClick={() => {
                                  setFromOptionDropDown(!fromOptionDropDown);
                                }}
                              >
                                {selectedCurr ? (
                                  <> {gettingLogos(selectedCurr)}</>
                                ) : null}
                                <span className="w-pop-drop-cur">
                                  {selectedCurr?.asset?.ticker}
                                </span>
                              </div>
                            </div>
                            <ul
                              class={
                                `n-currencyDropDown w-currency-height ` +
                                (fromOptionDropDown ? "d-block" : "d-none")
                              }
                            >
                              <ul className="w-pd-outer list-unstyled n-learnFilterLabels mb-2">
                                <li
                                  className="d-flex flex-row justify-content-between align-items-center"
                                  style={{ margin: "0 4px" }}
                                >
                                  <button
                                    className="alltype alltypesDark"
                                    style={{
                                      color: "#fff",
                                      fontFamily: "DM Sans",
                                    }}
                                    onClick={filterAllTypeTo}
                                  >
                                    All
                                  </button>
                                </li>
                                <li
                                  className="d-flex flex-row justify-content-center align-items-center"
                                  style={{ margin: "0 4px" }}
                                >
                                  <button
                                    className="alltype-nonActive alltype-nonActiveDark"
                                    style={{
                                      color: "#fff",
                                      fontFamily: "DM Sans",
                                      whiteSpace: "nowrap",
                                    }}
                                    onClick={filterNativeTo}
                                  >
                                    Native
                                  </button>
                                </li>
                                <li
                                  className="d-flex flex-row justify-content-center align-items-center"
                                  style={{ margin: "0 4px" }}
                                >
                                  <button
                                    className="alltype-nonActive alltype-nonActiveDark"
                                    style={{
                                      color: "#fff",
                                      fontFamily: "DM Sans",
                                    }}
                                    onClick={filterERC20To}
                                  >
                                    ERC20
                                  </button>
                                </li>
                                <li
                                  className="d-flex flex-row justify-content-center align-items-center"
                                  style={{ margin: "0 4px" }}
                                >
                                  <button
                                    className="alltype-nonActive alltype-nonActiveDark"
                                    style={{
                                      color: "#fff",
                                      fontFamily: "DM Sans",
                                    }}
                                    onClick={filterBEP2To}
                                  >
                                    BEP2
                                  </button>
                                </li>
                              </ul>
                              <div class="w-pd-outer d-flex form-group has-search mb-2 n-inputSearch w-100 ">
                                <input
                                  type="text"
                                  value={search}
                                  class="form-control n-tableSearch w-100 n-tableSeachDark"
                                  placeholder="Search"
                                  onChange={implementSearch}
                                />
                                <img
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    marginLeft: "-35px",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                  }}
                                  src={Images.searchicon}
                                />
                              </div>

                              {popUpData
                                ?.filter((val) => {
                                  return val?.asset?.ticker
                                    ?.toLowerCase()
                                    .includes(search?.toLowerCase());
                                })
                                .map((d, key) => {
                                  return (
                                    <>
                                      <li
                                        class="d-flex flex-row align-items-center w-hover-drop"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          setSelectedCurr(d);
                                          console.log(d);
                                          setFromOptionDropDown(false);
                                        }}
                                      >
                                        {gettingLogos(d)}
                                        <div class="d-flex flex-row align-items-center justify-content-between w-100 n-currencyDetails">
                                          <div class="n-currencyName d-flex flex-column justify-content-start">
                                            <p>{d?.asset?.ticker}</p>
                                            <span>Native</span>
                                          </div>
                                        </div>
                                      </li>
                                      <hr className="m-0"></hr>
                                    </>
                                  );
                                })}
                            </ul>
                          </div>
                          <div className="d-flex align-items-center">
                            <div class="input-group w-pop-input-outer">
                              <input
                                style={{ marginRight: "30px" }}
                                disabled={inSufficientBalance}
                                style={
                                  inSufficientBalance
                                    ? { cursor: "not-allowed" }
                                    : null
                                }
                                type="number"
                                placeholder="0"
                                value={fromAmount}
                                onChange={(e) => {
                                  if (e.target.value >= 0) {
                                    setFromAmount(e.target.value);
                                  }
                                }}
                                class="form-control input-focus n-btnWhite liquidityModal"
                                aria-label="Text input with segmented dropdown button"
                              />
                            </div>
                            <div className="d-block">
                              <p
                                className="w-pop-balance"
                                style={{ fontWeight: "400" }}
                              >
                                Balance:
                              </p>
                              {inSufficientBalance ? (
                                <>
                                  <p className="w-pop-balance wpb1">
                                    0 {selectedCurr?.asset?.ticker}
                                  </p>
                                </>
                              ) : (
                                <p
                                  className="w-pop-balance wpb1"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    setFromAmount(
                                      Number(
                                        selectedCurr?.amount?.amount().c[0] /
                                          Math.pow(
                                            10,
                                            selectedCurr?.amount?.decimal
                                          )
                                      )
                                    );
                                  }}
                                >
                                  {Number(
                                    selectedCurr?.amount?.amount().c[0] /
                                      Math.pow(
                                        10,
                                        selectedCurr?.amount?.decimal
                                      )
                                  )}{" "}
                                  {selectedCurr?.asset?.ticker}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="w-pop-ml-balance d-flex justify-content-between align-items-center">
                          <div class="w-currencySelect" ref={myRefSwap2}>
                            <div class="w-currency-new">
                              {/* <span>+</span> */}
                              <div class="d-flex flex-row align-items-center">
                                <span
                                  style={{ marginRight: "20px" }}
                                  className="w-pop-plus"
                                >
                                  +
                                </span>
                                {RUNE ? (
                                  <>
                                    {" "}
                                    <img
                                      src={RUNE?.logo}
                                      width="24px"
                                      height="24px"
                                    />
                                  </>
                                ) : null}
                                <span className="w-pop-drop-cur">
                                  {RUNE?.asset}
                                </span>
                                {/* <img
                                        style={{ width: "18px" }}
                                        src={Images.iconarowdown}
                                      /> */}
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center">
                            <div class="input-group w-pop-input-outer">
                              <input
                                disabled
                                type="number"
                                placeholder="0"
                                value={toAmount}
                                class="form-control input-focus n-btnWhite liquidityModal"
                                aria-label="Text input with segmented dropdown button"
                              />
                            </div>
                            <div
                              className="w-pop-ml-balance d-block  justify-content-end"
                              // style={{ marginTop: "12px" }}
                            >
                              <p
                                className="w-pop-balance"
                                style={{ fontWeight: "400" }}
                              >
                                Balance:
                              </p>
                              <p className="w-pop-balance wpb1">
                                {runeBalance} RUNE
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            fontSize: 10,
                            color: "red",
                            marginLeft: 16,
                            marginTop: -14,
                            // height: "5px",
                            // whiteSpace: "nowrap",
                          }}
                        >
                          {emptyError && <>* Swapping amount is required</>}
                          {slipError ? (
                            <>
                              * Your input value is exceeding from the slip
                              amount.
                            </>
                          ) : null}
                        </div>
                        <hr
                          style={{ marginTop: "20px", marginBottom: "32px" }}
                          class="solid solidDark"
                        />
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="w-pop-ml-balance">
                            <p
                              className="w-pop-drop-cur"
                              style={{ marginBottom: "0", marginLeft: "74px" }}
                            >
                              TOTAL
                            </p>
                          </div>
                          <div class="d-flex flex-row align-items-center">
                            <div
                              class="input-group w-pop-input-outer"
                              style={{ marginRight: "130px" }}
                            >
                              <input
                                type="number"
                                placeholder="0"
                                value={inputValue}
                                onChange={(e) => {
                                  if (e.target.value >= 0) {
                                    setInputValue(e.target.value);
                                  }
                                }}
                                class="form-control input-focus n-btnWhite liquidityModal"
                                aria-label="Text input with segmented dropdown button"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>

                  <div class="w-liquiditySlip">
                    <p class="w-pop-earn text-center mb-3">
                      Estimated earnings as LPer (30d)
                    </p>
                    <p class="w-pop-earn-text text-center">
                      Stay in the Pool for 100 days to have full IL protection.
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ marginLeft: "10px" }}
                      >
                        <path
                          d="M8.50001 1C7.01665 1 5.5666 1.43987 4.33323 2.26398C3.09986 3.08809 2.13856 4.25943 1.57091 5.62987C1.00325 7.00032 0.854725 8.50832 1.14411 9.96318C1.4335 11.418 2.14781 12.7544 3.1967 13.8033C4.2456 14.8522 5.58197 15.5665 7.03683 15.8559C8.49169 16.1453 9.99969 15.9968 11.3701 15.4291C12.7406 14.8614 13.9119 13.9001 14.736 12.6668C15.5601 11.4334 16 9.98336 16 8.5C16 6.51088 15.2098 4.60322 13.8033 3.1967C12.3968 1.79018 10.4891 1 8.50001 1Z"
                          stroke="#777E90"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M6.11377 6.21123C6.11377 6.21123 6.14957 5.46549 6.94772 4.8233C7.42116 4.44191 7.98877 4.33154 8.50013 4.32387C8.9659 4.3179 9.38181 4.39504 9.63067 4.5135C10.0568 4.71634 10.8865 5.21151 10.8865 6.26449C10.8865 7.37245 10.1621 7.87572 9.33664 8.42927C8.51121 8.98282 8.28706 9.58367 8.28706 10.2046"
                          stroke="#777E90"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                        />
                        <path
                          d="M8.2499 13.2682C8.71934 13.2682 9.0999 12.8876 9.0999 12.4182C9.0999 11.9487 8.71934 11.5682 8.2499 11.5682C7.78046 11.5682 7.3999 11.9487 7.3999 12.4182C7.3999 12.8876 7.78046 13.2682 8.2499 13.2682Z"
                          fill="#777E90"
                        />
                      </svg>
                    </p>
                    <p class="w-pop-earn-text text-center">
                      * Caluclation is based on the Assets Price right now.
                    </p>
                    <div className="d-flex justify-content-around mt-3">
                      <div class="d-flex align-items-end">
                        <p class="w-pop-month text-center">$0.00</p>
                        <p class="w-pop-apr">&nbsp;/month *</p>
                      </div>
                      <div class="d-flex align-items-end">
                        <p class="w-pop-month text-center">13.1%&nbsp;</p>
                        <p class="w-pop-apr">APR *</p>
                      </div>
                    </div>
                    <div class="d-flex flex-row justify-content-between align-items-center py-3">
                      <div class="d-flex flex-row align-items-center fairPriceDropdown" onClick={handleFairPriceDropdown}>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10 20C4.45455 20 0 15.5455 0 10C0 4.45455 4.45455 0 10 0C15.5455 0 20 4.45455 20 10C20 15.5455 15.5455 20 10 20ZM13.3249 6.74409C13.5821 6.42065 14.0965 6.36674 14.4051 6.63628C14.7137 6.90581 14.7652 7.44489 14.508 7.76833L9.36403 14.1833C9.10683 14.5068 8.59243 14.5607 8.2838 14.2911L4.94022 11.3801C4.63158 11.1106 4.58014 10.5715 4.83734 10.2481C5.09454 9.92463 5.60894 9.87072 5.91757 10.1403L8.69531 12.5661L13.3249 6.74409ZM18 10C18 14.4 14.4 18 10 18C5.6 18 2 14.4 2 10C2 5.6 5.6 2 10 2C14.4 2 18 5.6 18 10Z"
                            fill="#3BB54A"
                          />
                        </svg>
                        <p class="n-showData">Fair Price</p>
                        <svg
                          width="17"
                          height="10"
                          viewBox="0 0 17 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginLeft: "10px" }}
                        >
                          <path
                            d="M8.5 10L0.324442 1.879C-0.108147 1.4493 -0.108147 0.751979 0.324442 0.322277C0.757031 -0.107426 1.45904 -0.107426 1.89163 0.322277L8.5 6.88654L15.1084 0.322277C15.541 -0.107426 16.243 -0.107426 16.6756 0.322277C17.1081 0.751979 17.1081 1.4493 16.6756 1.879L8.5 10V10Z"
                            fill="#3BB54A"
                          />
                        </svg>
                      </div>
                      {/* <p className="w-pop-refresh">
                        Refreshing pool data every 10s…
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ width: "30px", marginLeft: "10px" }}
                          class="n-modalRefresh"
                        >
                          <rect width="30" height="30" rx="10" fill="#F0F0F0" />
                          <path
                            d="M16.4972 12.1612C16.4972 12.2976 16.5514 12.4285 16.6479 12.525C16.7444 12.6214 16.8752 12.6757 17.0117 12.6757H22.1752V7.51683C22.1752 7.37976 22.1208 7.2483 22.0238 7.15137C21.9269 7.05445 21.7955 7 21.6584 7C21.5213 7 21.3899 7.05445 21.2929 7.15137C21.196 7.2483 21.1416 7.37976 21.1416 7.51683V10.8868C20.1737 9.46955 18.7626 8.41385 17.1297 7.88552C15.4969 7.35718 13.7348 7.38612 12.1202 7.9678C10.5056 8.54948 9.12986 9.65094 8.2091 11.0992C7.28834 12.5475 6.87468 14.2606 7.03307 15.9695C7.19145 17.6784 7.91292 19.2862 9.08418 20.5406C10.2554 21.795 11.8102 22.6249 13.5042 22.8999C15.1982 23.1749 16.9356 22.8795 18.4435 22.0601C19.9515 21.2406 21.1445 19.9435 21.8354 18.3725C21.8865 18.2451 21.8861 18.1028 21.8342 17.9757C21.7823 17.8487 21.683 17.7467 21.5573 17.6915C21.4316 17.6364 21.2894 17.6322 21.1607 17.6801C21.032 17.7279 20.927 17.8239 20.8678 17.9478C20.2682 19.3132 19.2298 20.4394 17.9173 21.1474C16.6047 21.8554 15.0933 22.1048 13.6229 21.856C12.1525 21.6071 10.8073 20.8743 9.80087 19.7738C8.79442 18.6733 8.18436 17.2681 8.06752 15.7814C7.95067 14.2947 8.33373 12.8115 9.1559 11.5673C9.97807 10.3231 11.1922 9.38908 12.6057 8.91357C14.0192 8.43806 15.551 8.44826 16.958 8.94256C18.3651 9.43686 19.5667 10.3869 20.3722 11.642H17.0164C16.948 11.6414 16.8802 11.6544 16.817 11.6802C16.7537 11.7061 16.6962 11.7443 16.6479 11.7927C16.5995 11.841 16.5613 11.8985 16.5354 11.9618C16.5096 12.025 16.4966 12.0928 16.4972 12.1612Z"
                            fill="#AAAAAA"
                            stroke="#AAAAAA"
                            stroke-width="0.5"
                          />
                        </svg>
                      </p> */}
                    </div>
                    <div class={fairPriceDropdown ? "n-slippageFeeNew" : "n-slippageFee"}>
                      <div class="d-flex flex-row justify-content-between">
                        <div class="d-flex align-items-center">
                          <p class="n-slippageText">Slippage</p>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginLeft: "10px" }}
                          >
                            <path
                              d="M8.50001 1C7.01665 1 5.5666 1.43987 4.33323 2.26398C3.09986 3.08809 2.13856 4.25943 1.57091 5.62987C1.00325 7.00032 0.854725 8.50832 1.14411 9.96318C1.4335 11.418 2.14781 12.7544 3.1967 13.8033C4.2456 14.8522 5.58197 15.5665 7.03683 15.8559C8.49169 16.1453 9.99969 15.9968 11.3701 15.4291C12.7406 14.8614 13.9119 13.9001 14.736 12.6668C15.5601 11.4334 16 9.98336 16 8.5C16 6.51088 15.2098 4.60322 13.8033 3.1967C12.3968 1.79018 10.4891 1 8.50001 1Z"
                              stroke="#777E90"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                            />
                            <path
                              d="M6.11377 6.21123C6.11377 6.21123 6.14957 5.46549 6.94772 4.8233C7.42116 4.44191 7.98877 4.33154 8.50013 4.32387C8.9659 4.3179 9.38181 4.39504 9.63067 4.5135C10.0568 4.71634 10.8865 5.21151 10.8865 6.26449C10.8865 7.37245 10.1621 7.87572 9.33664 8.42927C8.51121 8.98282 8.28706 9.58367 8.28706 10.2046"
                              stroke="#777E90"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                            />
                            <path
                              d="M8.2499 13.2682C8.71934 13.2682 9.0999 12.8876 9.0999 12.4182C9.0999 11.9487 8.71934 11.5682 8.2499 11.5682C7.78046 11.5682 7.3999 11.9487 7.3999 12.4182C7.3999 12.8876 7.78046 13.2682 8.2499 13.2682Z"
                              fill="#777E90"
                            />
                          </svg>
                        </div>
                        <p class="n-slippageValue">0.01%</p>
                      </div>
                      <div
                        class="d-flex flex-row justify-content-between"
                        style={{ marginTop: "10px" }}
                      >
                        <div class="d-flex align-items-center">
                          <p class="n-slippageText">Total fee</p>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginLeft: "10px" }}
                          >
                            <path
                              d="M8.50001 1C7.01665 1 5.5666 1.43987 4.33323 2.26398C3.09986 3.08809 2.13856 4.25943 1.57091 5.62987C1.00325 7.00032 0.854725 8.50832 1.14411 9.96318C1.4335 11.418 2.14781 12.7544 3.1967 13.8033C4.2456 14.8522 5.58197 15.5665 7.03683 15.8559C8.49169 16.1453 9.99969 15.9968 11.3701 15.4291C12.7406 14.8614 13.9119 13.9001 14.736 12.6668C15.5601 11.4334 16 9.98336 16 8.5C16 6.51088 15.2098 4.60322 13.8033 3.1967C12.3968 1.79018 10.4891 1 8.50001 1Z"
                              stroke="#777E90"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                            />
                            <path
                              d="M6.11377 6.21123C6.11377 6.21123 6.14957 5.46549 6.94772 4.8233C7.42116 4.44191 7.98877 4.33154 8.50013 4.32387C8.9659 4.3179 9.38181 4.39504 9.63067 4.5135C10.0568 4.71634 10.8865 5.21151 10.8865 6.26449C10.8865 7.37245 10.1621 7.87572 9.33664 8.42927C8.51121 8.98282 8.28706 9.58367 8.28706 10.2046"
                              stroke="#777E90"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                            />
                            <path
                              d="M8.2499 13.2682C8.71934 13.2682 9.0999 12.8876 9.0999 12.4182C9.0999 11.9487 8.71934 11.5682 8.2499 11.5682C7.78046 11.5682 7.3999 11.9487 7.3999 12.4182C7.3999 12.8876 7.78046 13.2682 8.2499 13.2682Z"
                              fill="#777E90"
                            />
                          </svg>
                        </div>
                        <p class="n-slippageValue">$4.7</p>
                      </div>
                    </div>
                    <button
                      disabled={inSufficientBalance || slipError}
                      style={{
                        fontFamily: "DM Sans",
                        borderRadius: "25px",
                        fontWeight: "500",
                        letterSpacing: "0.5px",
                        height: "50px",
                      }}
                      style={
                        inSufficientBalance || slipError
                          ? { cursor: "not-allowed" }
                          : null
                      }
                      type="button"
                      class="n-primaryButton n-primaryDark w-100 mt-3"
                      onClick={submitLiquidity}
                    >
                      {inSufficientBalance ? (
                        <>Insufficient Balance</>
                      ) : (
                        <>Deposit</>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- modal end --> */}
        </Modal.Body>
      </Modal>

      <button class="btn n-primaryButton" onClick={handleAddLiqudityModal}>
        Deposit
      </button>
    </div>
  );
};
